import { useSelector } from "react-redux";

function useUserData() {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const username = userData?.["custom:custom_username"];
  const email = userData?.["cognito:username"];

  return {username, email};
}

export default useUserData;